import {getSubReducer} from './utils';
import CONSTANTS from './constants';

const {
	initialState
} = CONSTANTS;

export const NAME = CONSTANTS.NAME;

export * from './selectors';
export * from './tables';
export * from './filters';

/*** REDUCER ***/
export default (state = initialState, action) => {
  return getSubReducer(state, action);
}
/*** REDUCER END ***/




// WEBPACK FOOTER //
// ./components/qual/Table/ducks/index.js